import { Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setNFTDetailData,
  setTrendingCollectionDetail,
} from "../../redux/nftDetailSlice";
import { PageRoutes } from "../../utils/constants";
import "./NFTCard.scss";

const NFTCard = (props: any) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const item = props.item;
  const handleDetailsPage = async () => {
    if (props?.isTrending) {
      await dispatch(setTrendingCollectionDetail(item));
      navigate(PageRoutes.CollectionDetails);
    } else {
      await dispatch(setNFTDetailData(item));
      navigate(PageRoutes.Details);
    }
  };
  return (
    <Col lg={3} md={4} xs={6} onClick={handleDetailsPage}>
      <Tilt
        className="parallax-effect-img"
        tiltReverse={true}
        tiltMaxAngleX={10}
        tiltMaxAngleY={10}
        perspective={400}
        transitionSpeed={1200}
        scale={0.95}
        gyroscope={false}
      >
        <div className="card-main">
          <div className="card-image">
            <img src={item.imageUrl} alt="Hero NFT" className="inner-element" />
          </div>
          <div className="card-title">{item.name}</div>
        </div>
      </Tilt>
    </Col>
  );
};

export default NFTCard;
